import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params//valid-params";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { getAdvBuilds } from "@ugg/shared/api/data-parser/champions/adv-builds";
import { useChampionRecBuild } from "@ugg/shared/api/requests/champions/adv-builds";
import { ChampionProfilePagePlaceholder } from "@ugg/shared/components/Champions/ChampionProfilePagePlaceholder";
import { ChampionProfilePageError } from "@ugg/shared/components/Champions/ChampionProfilePageError";
import { normalizeRole } from "@ugg/shared/utils/role-helpers";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";
import { BootsTable } from "./BootsTable";
import { StartingItemsTable } from "./StartingItemsTable";
import { CoreItemsTable } from "./CoreItemsTable";

export function ItemPathsContainer({ className, ssr }: { className?: string; ssr?: boolean }) {
  const { championId, role } = useChampionProfileContext();

  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.ITEM_PATHS, queryParams, true);
  const { data, loading, error } = useChampionRecBuild(championId, CHAMPION_PAGES.ITEM_PATHS, {
    params: validatedQueryParams,
    ssr,
  });
  const recommendedBuild = getAdvBuilds(data, { ...validatedQueryParams, role: normalizeRole(role || "") });
  const { starting_items, core_items, core_items_with_boots, boots } = recommendedBuild || {};

  const patch = validatedQueryParams.patch;

  if (loading) {
    return <ChampionProfilePagePlaceholder className="w-full" />;
  } else if (error || !starting_items || !core_items || !core_items_with_boots || !boots) {
    return <ChampionProfilePageError className="w-full" />;
  }

  return (
    <div className="flex flex-wrap gap-[12px] w-full">
      <div className="flex-[1_1_340px] flex flex-col gap-[12px]">
        <StartingItemsTable data={starting_items} spriteSize={30} patch={patch} ssr={ssr} webp />
        <BootsTable data={boots} spriteSize={30} patch={patch} ssr={ssr} webp />
      </div>
      <div className="flex-[1_1_340px]">
        <CoreItemsTable
          coreItems={core_items}
          coreItemsWithBoots={core_items_with_boots}
          spriteSize={30}
          patch={patch}
          ssr={ssr}
          webp
        />
      </div>
    </div>
  );
}
